import { io, Socket } from 'socket.io-client';
import { DefaultEventsMap } from '@socket.io/component-emitter';

const SOCKET_SERVER_ENDPOINT = process.env.REACT_APP_API_BASE_URL ?? '';
let socket: Socket<DefaultEventsMap, DefaultEventsMap>;

export const initSocket = (token: string | null) => {
  if (socket?.id) return
  socket = io(SOCKET_SERVER_ENDPOINT, {
    query: { token },
    reconnectionDelay: 10000, // defaults to 1000
    reconnectionDelayMax: 10000, // defaults to 5000,
  });

  socket.on('connect', () => {
    setTimeout(() => {
      socket.emit('ping', () => { });
    }, 1000);
    socket.on('pong', (msg: string) => {
      socket.emit('join-user-channel', {});
    });
    socket.on('join-user-channel', () => { });
  });
  socket.on('disconnect', () => {
    console.log('Socket disconnected. Attempting to reconnect...');
  });
  return socket;
};
